import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentAlterarSolicitacao from './ContentAlterarSolicitacao';

const AlterarSolicitacao = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentAlterarSolicitacao />
      <Bottom />
    </div>
  );
};

export default AlterarSolicitacao;
